import {Component, computed, input, output} from '@angular/core';
import {OptionsSelectComponent} from '../../../inputs/options-select/options-select.component';
import {SelectOption, SelectValue} from '../../../inputs/options-select/options-select.types';
import {FULFILLMENT_VALUES, NUMERIC_VALUES} from './attribute-fulfillment-boolean.types';

@Component({
  selector: 'app-attribute-fulfillment-boolean',
  imports: [OptionsSelectComponent],
  templateUrl: './attribute-fulfillment-boolean.component.html',
})
export class AttributeFulfillmentBooleanComponent {
  readonly score = input.required<number | null>();
  readonly disabled = input.required<boolean>();
  readonly testIdKey = input.required<string>();

  readonly valueChange = output<number>();

  readonly displayValue = computed<SelectValue>(() => {
    const score = this.score();
    if (score == undefined) {
      return undefined;
    }
    return score === NUMERIC_VALUES.YES ? FULFILLMENT_VALUES.YES : FULFILLMENT_VALUES.NO;
  });

  readonly options = computed<SelectOption[]>(() => [
    {directusKey: 'common.yes', value: FULFILLMENT_VALUES.YES},
    {directusKey: 'common.no', value: FULFILLMENT_VALUES.NO},
  ]);

  onValueChange(value: SelectValue): void {
    this.valueChange.emit(
      value === FULFILLMENT_VALUES.YES ? NUMERIC_VALUES.YES : NUMERIC_VALUES.NO,
    );
  }
}
